module.exports = __webpack_public_path__ + "img/light_bulb.b54b6280.svg";